import type { IValidatorParams } from "@edaz/services/baseValidationService";

export type IsAfterQuarterYearOptions = IsAfterQuarterYearOptions1;

interface IsAfterQuarterYearOptions1 {
  condition?: (entity: any) => string | undefined;
  after?: string;
}

export default function isAfterQuarterYear(
  value: string | undefined,
  options: IsAfterQuarterYearOptions,
  params?: IValidatorParams
) {
  if (value) {
    if (options.after) {
      return isAfterOrEqual(value, options.after);
    } else if (options.condition) {
      const after = options.condition(params?.entity);

      if (after) {
        return isAfterOrEqual(value, after);
      }
    }
  }

  return true;
}

function isAfterOrEqual(first: string, second: string) {
  const compared = compareQuarterYear(first, second);

  if (compared < 0) {
    return false;
  }

  return true;
}

function compareQuarterYear(first: string, second: string) {
  // Parse string e.g. 4Q-2021 to 4Q and 2021
  const firstSplit = first.split("-");
  const secondSplit = second.split("-");

  const firstYear = parseInt(firstSplit[1]);
  const secondYear = parseInt(secondSplit[1]);

  if (firstYear < secondYear) {
    return -1;
  } else if (firstYear > secondYear) {
    return 1;
  }

  // Parse string e.g. 4Q -> 4
  const firstQuarter = parseInt(firstSplit[0][0]);
  const secondQuarter = parseInt(secondSplit[0][0]);

  if (firstQuarter < secondQuarter) {
    return -1;
  } else if (firstQuarter > secondQuarter) {
    return 1;
  }

  return 0;
}
